import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { upperFirst } from 'lodash';

import { useGlobalStore } from '@Stores/global';

import BulkPublishAction from './BulkPublish';

export default function useDefinitions() {
  const { content_type } = useParams()
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const entityNamePlural = useThemeConfig(`types.${content_type}.plural`)
  const contentTypes = useThemeConfig('types')
  const customColumnsConfig = useThemeConfig(`types.${content_type}.post.custom`)

  const contentTypeOptions = useMemo(() => {
    if (!contentTypes) return undefined

    return Object.keys(contentTypes)
      .filter(value => content_type !== 'sweep' && !['sweep', content_type].includes(value))
      .map(value => ({ label: upperFirst(value), value }))
  }, [contentTypes, content_type])

  return useMemo(() => ({
    contentTypeOptions,
    hasSettings: !!contentTypes?.[content_type],
    customColumnsConfig,
    entityName: upperFirst(content_type),
    entityNamePlural: upperFirst(entityNamePlural),
    entityNameModule: 'cms',
    filters: { active: true },
    bulkActions: BulkPublishAction,
    basePath: `/cms/${content_type}`,
    defaultParams: {
      content_type,
    },
  }), [content_type, entityNamePlural, customColumnsConfig, contentTypes, contentTypeOptions])
}
